import PropTypes from "prop-types";
import React__default, { useState, useRef, useEffect } from "react";
import { COLORS } from "../../EatClubTheme.js";
import { u as useKeyboardListener } from "../../../hooks-BlwR7OOF.js";
import { Box } from "../Box/Box.js";
import { S as SvgDownArrow } from "../../../down_arrow-C-M7kokw.js";
import { S as SvgUpArrow } from "../../../up_arrow-BZ6O1kyX.js";
import { d as detectClickOutside, a as isEmpty } from "../../../helpers-N4qF49_T.js";
/* empty css                               */
import { DropdownSubMenu } from "./DropdownSubMenu.js";
const Dropdown = ({
  value = null,
  items,
  onSelect,
  direction = "standard",
  style = null,
  disabled = false,
  label,
  placeholder,
  selectedAtTop,
  // Whether to move the selected item to the top (or bottom if inverse)
  allowDeselect,
  // Whether it should be possible to select *nothing*
  error,
  usePopover,
  // Use a popover instead, to better show when inside a modal
  classes = null,
  children,
  // sub-components such as nested dropdowns
  valueOverride
  // Force the dropdown to show a specific thing in the value
}) => {
  const [isOpen, setOpen] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [hovered, setHovered] = useState(null);
  const [sortedItems, setSortedItems] = useState(items || []);
  const [clickedItem, setClickedItem] = useState(null);
  const dropdownRef = useRef(null);
  const [hasSelectedItem, setHasSelectedItem] = useState(false);
  const getItem = (itemValue) => {
    const itemIndex = sortedItems.findIndex((item) => item.value === itemValue);
    return sortedItems[itemIndex] || null;
  };
  const selectedItem = getItem(value);
  const selectedClickedItem = getItem(clickedItem);
  const listRef = useRef(null);
  useEffect(() => {
    let newItems = items;
    if (selectedAtTop) {
      const showSelectedAtBottom = direction === "inverse";
      if (showSelectedAtBottom) {
        newItems = [
          ...items.filter((item) => (item == null ? void 0 : item.value) !== value),
          ...items.filter((item) => (item == null ? void 0 : item.value) === value)
        ];
      } else {
        newItems = [
          ...items.filter((item) => (item == null ? void 0 : item.value) === value),
          ...items.filter((item) => (item == null ? void 0 : item.value) !== value)
        ];
      }
    }
    if (allowDeselect) {
      newItems = [{ label: "-", value: null }, ...newItems];
    }
    setSortedItems(newItems);
  }, [items, value]);
  const onBlur = () => {
    var _a;
    if (isOpen) {
      onClose();
    }
    if (document.activeElement !== listRef.current) {
      return;
    }
    (_a = document.activeElement) == null ? void 0 : _a.blur();
  };
  const dropdownStyles = {
    outerContainer: {
      // ...(style || {}),
      minWidth: "250px",
      ...(style == null ? void 0 : style.outerContainer) || {}
    },
    container: {
      // maxWidth: '500px',
      // height: "43px",
      position: "relative",
      ...(style == null ? void 0 : style.container) || {}
    },
    dropdown: {
      borderRadius: "6px",
      border: "1px solid #AEAEAE",
      cursor: "pointer",
      // userSelect: 'none',
      backgroundColor: "#FFFFFF",
      transitionDuration: "0.1s",
      whiteSpace: "nowrap",
      outline: "none",
      ...(style == null ? void 0 : style.dropdown) || {}
    },
    dropdownHover: {
      filter: "brightness(98%)",
      ...(style == null ? void 0 : style.dropdownHover) || {}
    },
    dropdownOpen: {
      borderRadius: "6px 6px 0 0",
      ...(style == null ? void 0 : style.dropdownOpen) || {}
    },
    disabled: {
      backgroundColor: "#ECECEC",
      cursor: "default",
      ...(style == null ? void 0 : style.disabled) || {}
    },
    dropdownContent: {
      ...(style == null ? void 0 : style.dropdownContent) || {}
    },
    dropdownContentInner: {
      borderRadius: "6px",
      padding: "10px 15px",
      // border: '1px solid transparent',
      width: "100%",
      maxWidth: "calc(100% - 40px)",
      fontSize: "16px",
      // height: "41px",
      lineHeight: "21px",
      position: "relative",
      color: COLORS.CHARCOAL,
      userSelect: "none",
      ...(style == null ? void 0 : style.dropdownContentInner) || {}
    },
    placeholder: {
      color: "#6E6E6D",
      textOverflow: "ellipsis",
      overflow: "hidden",
      userSelect: "none",
      ...(style == null ? void 0 : style.placeholder) || {}
    },
    label: {
      ...(style == null ? void 0 : style.label) || {}
    },
    dropdownArrow: {
      // paddingLeft: "5px",
      // paddingTop: "2px",
      // paddingRight: "20px",
      width: "11px",
      // height: "21px",
      margin: "10px",
      paddingRight: "10px",
      position: "absolute",
      right: 0,
      top: 0,
      cursor: "pointer",
      ...(style == null ? void 0 : style.dropdownArrow) || {}
    },
    menu: {
      position: "absolute",
      whiteSpace: "nowrap",
      pointerEvents: "none",
      // top: "0",
      top: direction === "standard" ? "42px" : "auto",
      bottom: direction === "inverse" ? "-42px" : "auto",
      left: "0",
      right: "0",
      border: "none",
      borderRadius: "0 0 6px 6px",
      boxShadow: "0 4px 14px 0 rgba(202,202,202,0.5)",
      // transitionDuration: '0.1s',
      transitionProperty: "all 0.1s, border-color 0s",
      zIndex: "20",
      overflowY: "auto",
      maxHeight: "300px",
      // overscrollBehavior: "contain",
      overflowX: "show",
      ...(style == null ? void 0 : style.menu) || {}
    },
    menuOpen: {
      pointerEvents: "auto",
      border: "1px solid #AEAEAE",
      backgroundColor: "#ffffff",
      ...(style == null ? void 0 : style.menuOpen) || {}
    },
    menuItem: {
      padding: "16px 20px",
      cursor: "pointer",
      // userSelect: 'none',
      // color: "#6D6D6D",
      backgroundColor: "#FFFFFF",
      transitionDuration: "0.1s",
      display: "flex",
      justifyContent: "space-between",
      ...(style == null ? void 0 : style.menuItem) || {}
    },
    menuItemHover: {
      filter: "brightness(98%)",
      ...(style == null ? void 0 : style.menuItemHover) || {}
    },
    menuItemSelected: {
      // color: color || null,
      fontWeight: "500",
      ...(style == null ? void 0 : style.menuItemSelected) || {}
    },
    spacer: {
      height: "1px",
      marginLeft: "16px",
      marginRight: "16px",
      backgroundColor: "#DCDCDB",
      ...(style == null ? void 0 : style.spacer) || {}
    },
    error: {
      fontSize: "12px",
      color: "#E7554B",
      ...(style == null ? void 0 : style.error) || {}
    },
    dropdownSubMenu: {
      position: "absolute",
      zIndex: "1",
      left: "100%",
      top: 0,
      border: "solid 1px #AEAEAE",
      borderRadius: "0 0 6px 6px",
      boxShadow: "0 4px 14px 0 rgba(202,202,202,0.5)",
      padding: Array.isArray(selectedClickedItem == null ? void 0 : selectedClickedItem.subItems) ? "0" : "12px",
      marginLeft: "16px",
      backgroundColor: "#FFFFFF",
      transitionDuration: "0.1s",
      whiteSpace: "nowrap",
      outline: "none",
      // width: '100%',
      // maxWidth: '100%',
      overflow: Array.isArray(selectedClickedItem == null ? void 0 : selectedClickedItem.subItems) ? "hidden" : "visible",
      cursor: "default",
      ...(style == null ? void 0 : style.dropdownSubMenu) || {}
    }
  };
  const onOpen = () => {
    if (disabled) {
      return;
    }
    setOpen(true);
  };
  const onClose = () => {
    setHoveredItem(null);
    setOpen(false);
    setClickedItem(null);
  };
  const handleSelect = (newValue, item, e) => {
    if (!(item == null ? void 0 : item.subItems)) {
      setOpen(false);
    } else {
      setClickedItem(newValue);
      return;
    }
    setHoveredItem(null);
    if (item == null ? void 0 : item.onSelect) {
      item.onSelect(newValue, e, dropdownRef);
    } else {
      onSelect(newValue, e, dropdownRef);
    }
  };
  const toggleOpen = (willOpen) => {
    if (willOpen) {
      onOpen();
    } else {
      onClose();
    }
  };
  const wrapperRef = useRef(null);
  detectClickOutside(wrapperRef, () => toggleOpen(false));
  const itemHeight = 54;
  const keyActions = [
    {
      key: "ArrowDown",
      action: (e) => {
        var _a;
        e.preventDefault();
        if (isOpen) {
          if (hoveredItem === null) {
            setHoveredItem(0);
          } else {
            const nextItem = hoveredItem + 1;
            if (nextItem < sortedItems.length) {
              setHoveredItem(nextItem);
              (_a = listRef == null ? void 0 : listRef.current) == null ? void 0 : _a.scrollTo({
                top: hoveredItem * itemHeight,
                behavior: "smooth"
              });
            }
          }
        } else {
          onOpen();
          setHoveredItem(0);
        }
      }
    },
    {
      key: "ArrowUp",
      action: (e) => {
        var _a;
        e.preventDefault();
        if (isOpen) {
          if (hoveredItem === null) {
            setHoveredItem(0);
          } else {
            const previousItem = hoveredItem - 1;
            if (previousItem >= 0) {
              setHoveredItem(previousItem);
              (_a = listRef == null ? void 0 : listRef.current) == null ? void 0 : _a.scrollTo({
                top: (hoveredItem - 1) * itemHeight,
                behavior: "smooth"
              });
            }
          }
        }
      }
    },
    {
      key: "Enter",
      action: (e) => {
        var _a, _b;
        if (hoveredItem === null && sortedItems.length === 1) {
          handleSelect((_a = sortedItems[0]) == null ? void 0 : _a.value, sortedItems[0], e);
        } else if (hoveredItem !== null) {
          handleSelect((_b = sortedItems[hoveredItem]) == null ? void 0 : _b.value, sortedItems[hoveredItem], e);
        }
      }
    }
  ];
  useKeyboardListener(listRef, onBlur, keyActions);
  const setRef = (ref) => {
  };
  return /* @__PURE__ */ React__default.createElement(Box, { style: dropdownStyles.outerContainer, ref: dropdownRef }, label && /* @__PURE__ */ React__default.createElement(Box, { className: "paragraph-small", style: dropdownStyles.label }, label), /* @__PURE__ */ React__default.createElement(Box, { ref: wrapperRef, className: "dropdown-container", style: dropdownStyles.container }, /* @__PURE__ */ React__default.createElement(
    Box,
    {
      className: `dropdown ${isOpen && "dropdown-open"} ${disabled ? "dropdown-disabled" : ""}`,
      tabIndex: disabled ? -1 : 0,
      onClick: (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleOpen(!isOpen);
      },
      ref: listRef,
      style: {
        ...dropdownStyles.dropdown,
        ...isOpen ? dropdownStyles.dropdownOpen : {},
        ...hovered && !isOpen ? dropdownStyles.dropdownHover : {},
        ...disabled ? dropdownStyles.disabled : {}
      },
      onMouseEnter: () => setHovered(true),
      onMouseLeave: () => setHovered(false)
    },
    /* @__PURE__ */ React__default.createElement(
      Box,
      {
        className: `dropdown-content ${classes == null ? void 0 : classes.dropdownContent}`
      },
      /* @__PURE__ */ React__default.createElement(Box, { style: dropdownStyles.dropdownContentInner }, valueOverride || (selectedItem == null ? void 0 : selectedItem.value) !== null && (selectedItem == null ? void 0 : selectedItem.label) || /* @__PURE__ */ React__default.createElement(Box, { style: dropdownStyles.placeholder }, placeholder)),
      /* @__PURE__ */ React__default.createElement(Box, { style: dropdownStyles.dropdownArrow }, isOpen ? /* @__PURE__ */ React__default.createElement(SvgUpArrow, { style: { marginBottom: "2px" } }) : (
        // <DownArrowSVG />
        /* @__PURE__ */ React__default.createElement(SvgDownArrow, { style: { marginBottom: "1px" } })
      ))
    )
  ), error && /* @__PURE__ */ React__default.createElement(Box, { style: dropdownStyles.error }, error), /* @__PURE__ */ React__default.createElement(
    Box,
    {
      style: { ...dropdownStyles.menu, ...isOpen ? dropdownStyles.menuOpen : {} },
      className: `dropdown-menu ${isOpen ? "visible" : "hidden"}`
    },
    /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, isOpen ? sortedItems.filter((item) => value !== null || (item == null ? void 0 : item.value) !== null).map((item, i) => /* @__PURE__ */ React__default.createElement(Box, { key: !isEmpty(item == null ? void 0 : item.key) ? item.key : item.value }, /* @__PURE__ */ React__default.createElement(
      Box,
      {
        ref: setRef,
        style: {
          ...dropdownStyles.menuItem,
          ...item.value === value && value !== null ? dropdownStyles.menuItemSelected : {},
          ...i === hoveredItem ? dropdownStyles.menuItemHover : {}
        },
        className: `dropdown-menu-item ${i === hoveredItem ? "dropdown-menu-item-hovered" : ""}`,
        onClick: (e) => {
          e.stopPropagation();
          handleSelect(item.value, item, e);
        },
        onMouseEnter: () => setHoveredItem(i)
      },
      /* @__PURE__ */ React__default.createElement(Box, null, item.label),
      /* @__PURE__ */ React__default.createElement(Box, null, (item == null ? void 0 : item.subItems) && /* @__PURE__ */ React__default.createElement(SvgUpArrow, { style: { marginBottom: "2px", transform: "rotate(90deg)" } }))
    ), i < (items == null ? void 0 : items.length) - 1 && /* @__PURE__ */ React__default.createElement(Box, { style: dropdownStyles.spacer }))) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null))
  ), isOpen && (selectedClickedItem == null ? void 0 : selectedClickedItem.subItems) && /* @__PURE__ */ React__default.createElement(Box, { style: dropdownStyles.dropdownSubMenu }, Array.isArray(selectedClickedItem == null ? void 0 : selectedClickedItem.subItems) ? /* @__PURE__ */ React__default.createElement(
    DropdownSubMenu,
    {
      items: selectedClickedItem == null ? void 0 : selectedClickedItem.subItems,
      onClose,
      onSelect: (newValue, e) => {
        if (selectedClickedItem == null ? void 0 : selectedClickedItem.onSelect) {
          selectedClickedItem.onSelect(newValue, e);
        } else {
          onSelect(newValue, e);
        }
        onClose();
      },
      style: dropdownStyles.dropdownSubMenu
    }
  ) : selectedClickedItem == null ? void 0 : selectedClickedItem.subItems(onClose))));
};
Dropdown.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      // Optional param used for the key. Useful if the value is not serializable
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.shape({})]),
      // eslint-disable-next-line react/forbid-prop-types
      value: PropTypes.any,
      subItems: PropTypes.func
    })
  ).isRequired,
  onSelect: PropTypes.func.isRequired,
  direction: PropTypes.string,
  style: PropTypes.shape({}),
  disabled: PropTypes.bool,
  classes: PropTypes.shape({})
};
export {
  Dropdown
};
//# sourceMappingURL=Dropdown.js.map
